import {RequestAxios} from "../../index";
import {CitiesList} from "./interfaces";
import {API_START} from "../../constants";

const cityUrl = `${API_START}/localities`;

export const getCitiesList = async () => {
    return await RequestAxios.get<CitiesList[]>(cityUrl)
}